
export enum DockManifestReportTypeCd {
	DOCK_MANIFEST = 'DockManifest',
	INBOUND_LOAD_AND_ROUTE_MANIFEST = 'InboundLoadAndRouteManifest',
	INBOUND_STRIP_MANIFEST = 'InboundStripManifest',
	LINEHAUL_CLOSED_LOAD_MANIFEST = 'LinehaulClosedLoadManifest',
	LINEHAUL_LOAD_MANIFEST = 'LinehaulLoadManifest',
	LINEHAUL_STRIP_MANIFEST = 'LinehaulStripManifest'}

